












































































import 'vue-awesome/icons/list'
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/pencil-alt'
import 'vue-awesome/icons/chevron-right'
import 'vue-awesome/icons/chevron-down'

export default
  name: 'virtuals_category'
  props: ['category']
  data: ->
    hidden: true
    display_tooltip: { }
  components:
    balance:   require('components/inside/elements/balance.vue').default
    editable_balance: require('components/inside/pages/accounts/editable_balance.vue').default
    goal_info: require('./goal_info.vue').default
  computed:
    virtuals: -> @category.children()
    hideable:   -> @virtuals[0] && @virtuals[0].hidden == true
    visible:    -> !@hideable || !@hidden
    isGoal:     -> @virtuals[0] && @virtuals[0].isGoal()
    isFund:     -> @virtuals[0] && @virtuals[0].isFund()
    isReserves: -> @virtuals[0] && @virtuals[0].isRS()
    isHM:       -> @virtuals[0] && @virtuals[0].isHM()
    saved_percentage_bg: ->
      (virtual) ->
        width = virtual.saved_percent()
        width = 0 if width == 100
        "background-size: #{width}% 100%"
    sum: -> _.sumBy @virtuals, (virtual) => virtual.universalBalance(@$store.getters.default_currency)
  mounted: ->
    component = @
    requestIdleCallback =>
      @sortable = new Sortable $(@$el).find('tbody')[0],
        sort: true
        delay: (if @HM.is_touch then 100 else 0)
        draggable: '.virtual-row'
        handle: '.virtual-name'
        onSort: (evt) -> component.sortVirtuals @toArray()
  methods:
    showSavingsTooltip: (virtual) ->
      # @display_tooltip[virtual.id] = true
      @$set @display_tooltip, virtual.id, true
      @$nextTick =>
        @tooltip = $(@$el).find('.el-tooltip__popper').show()
        if @tooltip.length
          @popper = new Popper($(".virtual-row##{virtual.id}"), @tooltip, { placement: 'left' })
    hideSavingsTooltip: (virtual) ->
      @$set @display_tooltip, virtual.id, false
    editMobile: (virtual) ->
      return if !HM.is_mobile
      @edit(virtual)
    edit: (virtual)   -> @$store.commit 'VIRTUALS/EDIT', virtual
    history: (virtual) ->
      @$store.dispatch 'showTransactionsHistory',
        mode: 'virtual'
        filter: { virtual_id: virtual.id }
    sortVirtuals: (virtual_ids) ->
      payload =
        virtual_ids: virtual_ids
      @$store.dispatch('sortVirtuals', payload).then (res) =>
        HM.track "virtual-sort"
        @$message
          message: @$t('Done')
          type: 'success'

